<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button type="button" class="btn btn-primary">
                        <icon name="print"></icon>
                        พิมพ์ใบลดหนี้
                    </button>
                </form>
            </div>
            <br/>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>เลขที่ใบลดหนี้</th>
                    <th>วันที่</th>
                    <th>ชื่อเซลล์</th>
                    <th>ลูกค้า</th>
                    <th>เลขที่ใบคืนสินค้า</th>
                    <th>ยอดคืนสินค้า</th>
                    <th>ผู้สร้างใบลดหนี้</th>
                    <th>พิมพ์ใบลดหนี้</th>
                    <th>ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in creditNoteTable">
                    <td>{{data.credit_note_no}}</td>
                    <td>{{data.date | moment('DD/MM/YYYY')}}</td>
                    <td>{{data.sale_return_product && data.sale_return_product.sale ? data.sale_return_product.sale.name : "-"}}</td>
                    <td>{{data.sale_return_product && data.sale_return_product.customer ? data.sale_return_product.customer.customer_id + data.sale_return_product.customer.store_name : "-"}}</td>
                    <td>{{data.sale_return_product ? data.sale_return_product.cn_number : "-"}}</td>
                    <td>{{data.sale_return_product ? data.sale_return_product.return_price : 0 | currency}}</td>
                    <td>{{data.user ? data.user.name : '-'}}</td>
                    <td>
                        <button class="btn btn-primary">
                            <icon name="print"></icon>
                            พิมพ์ใบลดหนี้
                        </button>
                    </td>
                    <td>
                        <a>
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CreditNoteList",
        data(){
          return{
              creditNoteTable : [],
              dataPaginate:{
                  current_page :1,
                  from : 1,
                  last_page : 1,
                  per_page : 1,
                  total : 1,
                  to : 1
              },
          }
        },
        computed:{

        },
        created() {
            this.getCreditNoteTable(1);
        },
        methods:{
            getCreditNoteTable(page){
                this.$store.dispatch("SaleReturnProduct/getCreditNote",page).then(res=>{
                    this.creditNoteTable = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.from,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to,
                    };
                })
            },
        },
    }
</script>

<style scoped>

</style>
